import { useStore } from '@back-office/core';
import { RootStoreModel } from '../stores';

export type MapStore<T> = (store: RootStoreModel) => T;

const useInject = <T>(mapStore: MapStore<T>): T => {
  const store = useStore();
  return mapStore(store as unknown as RootStoreModel);
};

export default useInject;
